import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';

import { Routes, Route } from 'react-router-dom';
import Login from './Login';
import Alumnos from './Alumnos';
import Resultados from "./Resultados";
import Liquidacion from "./Liquidacion";
import VerLiquid from "./VerLiquid";
import Secciones from "./Secciones";
import VarAlumnos from "./VarAlumnos";
import VarSecciones from "./VarSecciones";
import Favoritos from "./Favoritos";
import Logoff from './Logoff';

import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>

      
      <Routes>
        <Route path="*" element={<App />} />
        
      </Routes>
      
  
       </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
